__turbopack_context__.v({
  "headerLayout": "nv1JJW_headerLayout",
  "logo": "nv1JJW_logo",
  "logoCompact": "nv1JJW_logoCompact",
  "wrapper": "nv1JJW_wrapper",
});
